import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';
import { hasUserAccessToAiStudio } from '../services/ai-studio.service';
import ms from 'ms';

const STALE_TIME_AI_ACCESS = ms('18h');

export const AI_STUDIO_ACCESS_QUERY_KEY = ['ai-studio-access'];

const useHasAiStudioAccess = () => {
    const {
        isSuccess: hasUserAccess,
        error: hasUserAccessError,
        isLoading: isUserAccessLoading,
    } = useAuthenticatedQuery({
        queryKey: AI_STUDIO_ACCESS_QUERY_KEY,
        queryFn: hasUserAccessToAiStudio,
        staleTime: STALE_TIME_AI_ACCESS,
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    return {
        hasUserAccessAiStudio: hasUserAccess && !hasUserAccessError,
        isUserAccessLoading,
    };
};

export default useHasAiStudioAccess;
